exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-404-component .btn {\n  transition: none;\n}", ""]);

// exports
